/**
 * lib/qr-svg — детерминированный QR-код → inline-SVG (без рантайм-CDN, без canvas).
 *
 * ЗАЧЕМ / WHY THIS EXISTS: карта приёма доната (`components/crypto-receive-card`)
 * показывает QR адреса, чтобы игрок отсканировал его кошельком с телефона. Генерация —
 * ЛОКАЛЬНАЯ и ДЕТЕРМИНИРОВАННАЯ (одинаковый адрес → одинаковый SVG): лёгкая зависимость
 * `qrcode-generator` (pure-JS, MIT, без своих зависимостей), без обращения к внешним
 * QR-API/CDN (приватность + офлайн + отсутствие трекинга). Возвращаем ВЕКТОР (SVG), а не
 * растр — масштабируется от размера карты (cqw) без потери чёткости.
 *
 * Модули рисуем как ОДИН `<path>` единичных квадратов с `fill: currentColor` → цвет
 * модулей задаёт CSS-хост (`components/crypto-receive-card.css` ставит тёмный --qr-ink
 * на БЕЛОЙ подложке в ОБЕИХ темах — QR обязан быть тёмным-на-светлом для сканируемости,
 * это не «тема», а требование считывания). `shape-rendering: crispEdges` — без сглаживания
 * на границах модулей. Тихая зона (quiet zone) — поля по краям (marginModules, дефолт 2).
 *
 * SCOPE: строка → SVG-разметка QR. Без DOM-вставки, без стилей (их даёт хост).
 * Cross-references: components/crypto-receive-card; lib/donate-targets.
 */

import qrcode from 'qrcode-generator';

/**
 * Построить inline-SVG QR-кода для `text`. `marginModules` — тихая зона по краям (в
 * модулях). EC-уровень 'M' (~15% избыточности) — баланс плотность/устойчивость для
 * крипто-адресов (34–42 символа). typeNumber 0 = авто-подбор версии под длину.
 */
export function qrSvg(text: string, marginModules = 2): string {
  const qr = qrcode(0, 'M');
  qr.addData(text);
  qr.make();
  const n = qr.getModuleCount();
  const dim = n + marginModules * 2;

  let path = '';
  for (let row = 0; row < n; row++) {
    for (let col = 0; col < n; col++) {
      if (qr.isDark(row, col)) {
        path += `M${col + marginModules} ${row + marginModules}h1v1h-1z`;
      }
    }
  }

  return (
    `<svg class="qr-svg" viewBox="0 0 ${dim} ${dim}" width="100%" height="100%" ` +
    `preserveAspectRatio="xMidYMid meet" shape-rendering="crispEdges" fill="currentColor" ` +
    `role="img" aria-hidden="true" focusable="false">` +
    `<path d="${path}"/></svg>`
  );
}
